import React from 'react'
import { SectionWrapper } from '../../theme/layouts/MainLayout'
import { techBlack } from '../../common/utils/constant'
import "./thankYou.scss"
import { NavLink, useLocation } from 'react-router-dom';

function ThankYou() {
    const location = useLocation();
   
    const {message='', flag=false } = location?.state ?? {message:'', flag:false}; 
    return ( 
        <div className='letsTalk-wrapper-page'>
            <SectionWrapper bg={techBlack}>
                <section className=''>
                    <div className='title-section-1'>
                        <div><span className='energy-yellow'>Thank You!</span></div>
                        <p className='thanks-text-section'>{message}</p>
                        {flag && <p className='thanks-subtext'>In the meantime, give us a follow on <NavLink to="https://www.linkedin.com/company/best-buy-ads" target="_blank" className='energy-link-yellow'>LinkedIn</NavLink> for retail media insights, success stories and more. </p>}
                    </div>
                </section>
            </SectionWrapper>
        </div>
    )
}

export default ThankYou